/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Driver } from '@shared/models';

@Component({
    selector: 'app-driver-deactivation-confirmation',
    templateUrl: './driver-deactivation-confirmation.component.html',
    styleUrls: ['./driver-deactivation-confirmation.component.scss'],
    standalone: false
})
export class DriverDeactivationConfirmationComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { driver: Driver }
  ) {
  }
}
